/**
 * Fuzzy answer matching for quiz questions.
 * Normalises input by removing articles, punctuation, and plurals.
 */

function normalise(s: string): string {
  let t = s.trim().toLowerCase();
  t = t.replace(/[^a-z\s]/g, "");
  t = t.replace(/\b(a|an|the)\b/g, "");
  t = t.replace(/\b(one|two|three|four|five|six|seven|eight|nine|ten)\b/g, "");
  t = t.replace(/\s+/g, " ").trim();
  if (t.endsWith("s") && t.length > 1) {
    t = t.slice(0, -1);
  }
  return t;
}

export function fuzzyMatch(userAnswer: string, correctAnswer: string): boolean {
  return normalise(userAnswer) === normalise(correctAnswer);
}

/** Format seconds as M:SS */
export function fmtTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}
